module.exports = __webpack_public_path__ + "img/__icon_CYSTERNA_SILOS.df7dd3f6.svg";